export const termsPageCopy = {
  headerText: {
    paragraph: (
      <>
        <span
          style={{ display: "block", marginBottom: "3rem", fontWeight: "bold" }}
        >
          {`Effective date: 3 October 2024`}
        </span>
        {`These are Biom’s Terms of Use and they apply to all users of the Biom platform. Biom Studio and its affiliates ("Biom", “us”, “our” or "we") are dedicated to protecting the rights of our users ("users" or "you"). When you create a Biom account or use Biom, you agree to these terms and other policies we post, including the `}
        <a
          style={{ display: "inline", fontWeight: "bold" }}
          href="https://biom.studio/privacy"
        >{`Privacy Policy.`}</a>
      </>
    ),
  },
  subContent: [
    {
      subtitle: `What you should do`,
      subParagraphs: [
        `You can help to prevent unauthorised access to your account and information by choosing a strong and unique password. When using or accessing the Services, you must comply with all applicable laws, rules, and regulations.`,
      ],
    },
    {
      subtitle: `What you should not do`,
      subParagraphs: [
        <>
          {`Please do not engage in any behaviour that endangers the security of our platform and users. Below are some examples of things you should not do on Biom.`}
        </>,
        <>
          <span style={{ marginTop: "2rem" }} className="bulletPoint">
            <span>&#9702;</span>
            <span>{`You can't do anything unlawful, misleading, or fraudulent or for an illegal or unauthorized purpose.`}</span>
          </span>
        </>,
        <>
          <span className="bulletPoint">
            <span>&#9702;</span>
            <span>{`You can’t attack a person or group based on the following characteristics: caste, disability, ethnicity, gender identity, immigration status, national origin, race, religion, serious medical condition, sex or sexual orientation.`}</span>
          </span>
        </>,
        <>
          <span className="bulletPoint">
            <span>&#9702;</span>
            <span>{`You can’t promote, normalize, provide instructional advice about illicit drug usage, drug trafficking and the selling of drugs.`}</span>
          </span>
        </>,
        <>
          <span className="bulletPoint">
            <span>&#9702;</span>
            <span>{`You can’t share content depicting violent and graphic works including, but not limited to violent assault, harrassment, domestic violence, sexual violence, footage recorded during a violent attack, animal abuse.`}</span>
          </span>
        </>,
        <>
          <span className="bulletPoint">
            <span>&#9702;</span>
            <span>{`You can’t sell or purchase any account or data obtained from us or our Services.`}</span>
          </span>
        </>,
        <>
          <span className="bulletPoint">
            <span>&#9702;</span>
            <span>{`You can’t access or collect others’ personal information in unauthorized ways.`}</span>
          </span>
        </>,
        <>
          <span className="bulletPoint">
            <span>&#9702;</span>
            <span>{`This includes attempts to buy, sell, or transfer your account (including your username, and login credentials).`}</span>
          </span>
        </>,
        <>
          <span className="bulletPoint">
            <span>&#9702;</span>
            <span>{`You can't use a domain name or URL in your username without our prior written consent.`}</span>
          </span>
        </>,
        <>
          <span className="bulletPoint">
            <span>&#9702;</span>
            <span>{`You can't post someone else’s private or confidential information without permission or do anything that violates someone else's rights.`}</span>
          </span>
        </>,
      ],
    },
    {
      subtitle: `Moderators`,
      subParagraphs: [
        <>
          <span className="bulletPoint">
            <span>&#9702;</span>
            <span>{`You agree that when you moderate a comment section, you will take appropriate action, which may include removing content that violates policy.`}</span>
          </span>
        </>,
        <>
          <span className="bulletPoint">
            <span>&#9702;</span>
            <span>{`You are not authorized to act on behalf of Biom.`}</span>
          </span>
        </>,
        <>
          <span className="bulletPoint">
            <span>&#9702;</span>
            <span>{`You may not perform moderation actions in exchange for any form of compensation, gift, or favour.`}</span>
          </span>
        </>,
      ],
    },
    {
      subtitle: null,
      subParagraphs: [
        `If you engage in any prohibited behaviours or otherwise endanger the security of our platform and users, we can remove any content you share and terminate your account.`,
      ],
    },
  ],
};
